import { MaterialService } from './material.service';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { KiwixiService } from '../kiwixi/kiwixi.service';
import { KiwixiGlobals } from '../kiwixi/kiwixi.globals';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ExaminationVariants, ExaminationVariantsList } from '../model/examinationVariants.model';
import { AuthenticationService } from './authentification.service';

@Injectable()
export class ExaminationVariantService extends KiwixiService {

    apiExaminationVariants = environment.server + 'examinations_variants/';

    getExaminationVariantStatus() {
        return [
            {
                label: 'Brouillon',
                code: 'draft',
                valid: true
            },
            {
                label: 'A valider',
                code: 'moderate',
                valid: true
            },
            {
                label: 'Publiée',
                code: 'published',
                valid: true
            },
            {
                label: 'Désactivée',
                code: 'disabled',
                valid: true
            }
        ];
    }

    extractIdFromUrl(url) {
        if (url) {
            return parseInt(url.split('/')[url.split('/').length - 2], 0);
        }
        return null;
    }

    constructor(
        private _http: HttpClient,
        private _router: Router,
        kiwixiGlobals: KiwixiGlobals,
        private materialService: MaterialService,
        private authentificationService: AuthenticationService
    ) {
        super(_http, _router, kiwixiGlobals, materialService);
    }

    patchExaminationVariant(_id, params) {
        const url = this.apiExaminationVariants + _id + '/';
        const headers = this.createHttpClientAuthorizationHeader();
        return this._http.patch<ExaminationVariants>(url, params, { headers: headers })
            .pipe(
                catchError(this.handleErrorObservable<ExaminationVariants>(`Mise à jour d'une variante`)),
            );
    }

    getExaminationsVariantes(params: HttpParams): Observable<ExaminationVariantsList> {
        const header = this.createHttpClientAuthorizationHeader();
        return this._http.get<ExaminationVariantsList>(this.apiExaminationVariants + '?salt=' + Math.random(), {
            headers: header,
            params: params
        })
            .pipe(
                map(_Examinations => _Examinations),
                catchError(this.handleErrorObservable<ExaminationVariantsList>(`getObservableExaminationsVariants`))
            );
    }

    getExaminationsVarianteByUrl(url: string): Observable<ExaminationVariants> {
        const header = this.createHttpClientAuthorizationHeader();
        return this._http.get<ExaminationVariants>(url + '?salt=' + Math.random(), {
            headers: header,
        })
            .pipe(
                map(_Examinations => _Examinations),
                catchError(this.handleErrorObservable<ExaminationVariants>(`getObservableExaminationsVariants`))
            );
    }

    getExaminationsVariantById(id: string): Observable<ExaminationVariants> {
        const header = this.createHttpClientAuthorizationHeader();
        return this._http.get<ExaminationVariants>(this.apiExaminationVariants + id + '/' + '?salt=' + Math.random(), {
            headers: header,
        })
            .pipe(
                map(_Examinations => _Examinations),
                catchError(this.handleErrorObservable<ExaminationVariants>(`getObservableExaminationsVariants`))
            );
    }

    postExaminationVariantes(params): Observable<ExaminationVariants> {
        const headers = this.createHttpClientAuthorizationHeader();
        return this._http.post<ExaminationVariants>(this.apiExaminationVariants, params, { headers: headers })
            .pipe(
                catchError(this.handleErrorObservable<ExaminationVariants>(`Création d'une version`)),
            );
    }

    deleteExaminationVariant(id): Observable<ExaminationVariants> {
        const header = this.createHttpClientAuthorizationHeader();
        return this._http.delete<ExaminationVariants>(this.apiExaminationVariants + id + '/', {
            headers: header,
        })
            .pipe(
                catchError(this.handleErrorObservable<ExaminationVariants>(`delete ExaminationSlide`))
            );
    }

    postMarkExaminationVarianteAsView(id): Observable<any> {
        const headers = this.createHttpClientAuthorizationHeader();
        return this._http.post<any>(environment.server + 'examinations-variants/' + id + '/mark-viewed/', null, { headers: headers })
            .pipe(
                catchError(this.handleErrorObservable<any>(`Lecture d'un examen`)),
            );
    }

    
}
